import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header1 from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner1.jpg";
import weChatImg from "../../images/about/wechat.jpg";
//import weChatQldImg from "../../images/about/wechat_qld.jpg";
import youTubeImg from "../../images/about/youtube.png";
import facebookImg from "../../images/about/facebook.png";
import linkedInImg from "../../images/about/linkedin.png";

import { withTranslation } from "react-i18next";

import axios from "axios";

import { toast } from "react-hot-toast";

import i18next from "i18next";

class Contact2 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: "",
			email: "",
			contact_number: "",
			gender: "",
			age: "",
			school: "",
			content: "",
		};
		this.itemRefs = [];
	}
	componentDidMount() {

	}

	handleSubmit = async (event) => {
		event.preventDefault();
		try {
			axios.post(
				"https://leadingcoding.com.au/contact-api/public/api/v1/send_email",
				this.state,
				{
					headers: {
						"x-api-key": "Uc.T*>n_#.1}5)r8mlU!Q$SEKson+[",
					},
				}
			);
			await axios.post(
				"https://leadingcoding.com.au/contact-api/public/api/v1/contact",
				this.state,
				{
					headers: {
						"x-api-key": "Uc.T*>n_#.1}5)r8mlU!Q$SEKson+[",
					},
				}
			);
			this.setState({
				name: "",
				email: "",
				contact_number: "",
				gender: "",
				age: "",
				school: "",
				content: "",
			});
			toast.success(i18next.t("Submit_Succeed_Tip"), {
				position: "bottom-center",
				duration: 5000,
			});
		} catch (error) {
			toast.error(i18next.t("Submit_Fail_Tip"), {
				position: "bottom-center",
				duration: 2000,
			});
		}
	};

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value });
	};

	render() {
		const { t } = this.props;
		return (
			<>
				<Header1 />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("Contact_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("Contact_LinkHome")}</Link>
								</li>
								<li>{t("Contact_LinkContact")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="page-banner contact-page">
							<div className="container-fuild container">
								<div className="row m-lr0">
									<div className="col-lg-6 col-md-6 section-sp2 p-lr30">
										<div className="heading-bx left p-r15">
											<h2 className="title-head">{t("Contact_Information")}</h2>
										</div>
										<div className="row placeani">
											<div className="col-lg-3 pull-right">
												<div className="label">
													<h3>{t("Contact_Phone_Label")}</h3>
												</div>
											</div>
											<div className="col-lg-6 pull-right">
												<div className="value">
													<div style={{ fontSize: 28 + "px" }}>
														{t("Contact_Phone_Value")}
													</div>
												</div>
											</div>
										</div>
										<div className="row placeani">
											<div className="col-lg-3 pull-right">
												<div className="label">
													<h3>{t("Contact_Email_Label")}</h3>
												</div>
											</div>
											<div className="col-lg-6 pull-right">
												<div className="value">
													<div style={{ fontSize: 28 + "px" }}>
														{t("Contact_Email_Value")}
													</div>
												</div>
											</div>
										</div>
										<div className="row placeani">
											<div className="col-lg-3 pull-right" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Wechat_Label")}</h3>
												</div>
											</div>
											<div className="col-lg-6 pull-right">
												<div className="value">
													<img alt=""
														style={{ width: 100 + "px", height: 100 + "px" }}
														src={weChatImg}
													/>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-3" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Youtube_Label")}</h3>
												</div>
											</div>
											<div className="col-lg-6 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 100, height: 100 }}>
													<a
														rel="noreferrer"
														href="https://www.youtube.com/@LeadingCoding"
														target="_blank"
													>
														<img
															alt=""
															src={youTubeImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-3" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Facebook_Label")}</h3>
												</div>
											</div>
											<div className="col-lg-6 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 90, height: 90, paddingLeft: 10 }}>
													<a
														rel="noreferrer"
														href="https://www.facebook.com/profile.php?id=61550979300196"
														target="_blank"
													>
														<img
															alt=""
															src={facebookImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-3" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Linkedin_Label")}</h3>
												</div>
											</div>
											<div className="col-lg-6 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 100, height: 100 }}>
													<a
														rel="noreferrer"
														href="https://www.linkedin.com/company/leading-coding"
														target="_blank"
													>
														<img
															alt=""
															src={linkedInImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 section-sp2 p-lr30">
										<form
											className="contact-bx ajax-form"
											onSubmit={this.handleSubmit}
										>
											<div className="heading-bx left p-r15">
												<h2 className="title-head">{t("Contact2_Title1")}</h2>
											</div>
											<div className="row placeani">
												<div className="col-lg-6 ">
													<div className="form-group">
														<div className="input-group">
															<input
																name="name"
																value={this.state.name}
																onChange={this.handleChange}
																type="text"
																placeholder={t("Contact2_Placeholder1")}
																required
																className="form-control valid-character"
															/>
														</div>
													</div>
												</div>
												<div className="col-lg-6">
													<div className="form-group">
														<div className="input-group">
															<input
																name="email"
																value={this.state.email}
																onChange={this.handleChange}
																type="email"
																placeholder={t("Contact2_Placeholder2")}
																className="form-control"
																required
															/>
														</div>
													</div>
												</div>
												<div className="col-lg-6">
													<div className="form-group">
														<div className="input-group">
															<input
																name="contact_number"
																value={this.state.contact_number}
																onChange={this.handleChange}
																type="text"
																placeholder={t("Contact2_Placeholder3")}
																required
																className="form-control int-value"
															/>
														</div>
													</div>
												</div>
												<div className="col-lg-6">
													<div className="form-group">
														<div className="input-group">
															<input
																name="gender"
																value={this.state.gender}
																onChange={this.handleChange}
																type="text"
																placeholder={t("Contact2_Placeholder4")}
																required
																className="form-control"
															/>
														</div>
													</div>
												</div>
												<div className="col-lg-6">
													<div className="form-group">
														<div className="input-group">
															<input
																name="age"
																value={this.state.age}
																onChange={this.handleChange}
																type="number"
																placeholder={t("Contact2_Placeholder6")}
																required
																className="form-control"
																min="0"
																max="100"
															/>
														</div>
													</div>
												</div>
												<div className="col-lg-6">
													<div className="form-group">
														<div className="input-group">
															<input
																name="school"
																value={this.state.school}
																onChange={this.handleChange}
																type="text"
																placeholder={t("Contact2_Placeholder7")}
																required
																className="form-control"
															/>
														</div>
													</div>
												</div>
												<div className="col-lg-12">
													<div className="form-group">
														<div className="input-group">
															<textarea
																name="content"
																value={this.state.content}
																onChange={this.handleChange}
																rows="4"
																placeholder={t("Contact2_Placeholder5")}
																className="form-control"
																required
															></textarea>
														</div>
													</div>
												</div>
												<div className="col-lg-12 d-flex justify-content-end">
													<button
														name="submit"
														type="submit"
														value="Submit"
														className="btn button-md"
													>
														{t("Contact2_SendM")}
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
								<div className="row m-lr0">
									<div className="col-lg-6 col-md-6 section-sp2 p-lr30">
										<div className="heading-bx left p-r15">
											<h2 className="title-head">{t("Contact_Information_QLD")}</h2>
										</div> 
										<div className="row placeani">
											<div className="col-lg-3" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Youtube_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-6 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 100, height: 100 }}>
													<a
														rel="noreferrer"
														href="https://www.youtube.com/@LeadingCoding"
														target="_blank"
													>
														<img
															alt=""
															src={youTubeImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-3" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Facebook_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-6 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 90, height: 90, paddingLeft: 10 }}>
													<a
														rel="noreferrer"
														href="https://www.facebook.com/profile.php?id=61550979300196"
														target="_blank"
													>
														<img
															alt=""
															src={facebookImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-3" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Linkedin_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-6 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 100, height: 100 }}>
													<a
														rel="noreferrer"
														href="https://www.linkedin.com/company/leading-coding"
														target="_blank"
													>
														<img
															alt=""
															src={linkedInImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default withTranslation()(Contact2);
